export default {
  ru: "RU",
  kk: "KZ",
  hello: "Salem",
  attention: "Назар аударыңыз",
  cancel: "Бас тарту",
  update: "Жаңарту",
  close: "Жабу",
  "no-data": "Деректер жоқ",
  back: "Кері қарай",
  summary: "Барлығы",
  expand: "Кеңейту",
  questionnaire: {
    fio: "Толық аты",
    notice:
      "Құрметті тұтынушы! Көрсетілетін қызметтердің сапасын жақсарту мақсатында <u>Сауалнамамыздың</u> сұрақтарына жауап беруіңізді сұраймыз!",
    title:
      "Тұтынушы - заңды тұлғалардың қанағаттанушылығын бағалау сауалнамасы",
    title1: "Құрметті тұтынушы!",
    title21:
      "Көрсетілген қызмет пен сатылатын өнімнің сапасын арттыру мақсатында «Алатау Жарық Компаниясы» АҚ филиалы - «Энергосбыт» өзінің қызметі туралы Сіздің пікіріңізді білуге ұмтылады. Сізден төмендегі сұрақтарға жауап беруіңізді сұраймыз, «Алатау Жарық Компаниясы» АҚ филиалы - «Энергосбыт» мамандары алдағы уақытта Сіздің пікіріңізді міндетті түрде ескереді.",
    title3: "Қатысуыңызды сұраймыз!",
    title4: "Сіздің кәсіпорыныңыздың:",
    title5: "Көрсетілген көмегіңіз үшін алғыс білдіреміз!",
    "question-number": "{count}-дан №{num} сұрақ",
    send: "Сауалнаманы жіберу",
    next: "Келесі",
    fill: "Тауарлар/қызметтер тізбесін көрсетіңіз",
    select:
      "«Алатау Жарық Компаниясы» АҚ филиалы - «Энергосбыт» жұмысына қанағаттанушылық деңгейін 5-баллдық шәкіл бойынша бағалаңыз: 1 - жаман, 2 - қанағаттанарлықсыз, 3 - қанағаттанарлық, 4 - жақсы, 5 - өте жақсы.",
  },
  ui: {
    yes: "Иә",
    no: "Жоқ",
    attention: "Назар аударыңыз",
    cancel: "Болдырмау",
    update: "Жаңарту",
    close: "Жабу",
    wait: "Күтуіңізді сұраймыз...",
    user: "Пайдаланушы",
    document_loading:
      "Сіздің құжатыңыз жүктелуде және ол осы терезеде ашылатын болады. Күтуіңізді сұраймыз...",
  },
  "app-navigation": {
    "account-list": "Қолжетімді дербес шоттар",
    "account-info": "Дербес шоты бойынша ақпарат",
    "home-tooltip": "Қолжетімді дербес шоттар",
    "exit-tooltip": "Шығу",
    "service-info": "Қызметтер бойынша ақпарат",
    calculate: "Электр энергиясы бойынша төлемдерді есептеу",
    pays: "Төлемдер",
    invoices: "Түбіртектер",
    requests: "Өтінім беру",
    "change-pwd": "Құпиясөзді өзгерту",
    "change-email": "E-mail-ді өзгерту",
    "change-personal": "Жеке баптаулар",
  },
  reportsInfo: { "no-data": "Таңдалған кезеңде деректер жоқ" },
  "update-checker": {
    message:
      'Жеке кабинеттің жаңа нұсқасы қол жетімді.<br /><br />Жаңарту керек пе?<br /><br /> Бетті қайта жүктеу үшін "Жаңарту" түймесін басыңыз.Барлық енгізілген деректер жоғалады.',
  },
  maintenance: {
    message:
      '<center><b>Назар аударыңыз!</b> <br /><br /> <span style="font-weight: 400"> Техникалық жұмыстар жүргізілуде. <br /><br /> Келтірілген қолайсыздықтар үшін кешірім сұраймыз.</span> </center>',
  },
  "app-header": {
    feedback: "Кері байланыс",
    "contact-center": "Тәулік бойы жұмыс істейтін Контакт орталығы 356-99-99",
    departments: "АлматыЭнергоСбыт аудандық бөлімшелері (АЭЖБ)",
    "invoice-sign": "Электрондық түбіртекке жазылу",
    iconMapSite: "Сайттың картасына өту",
  },
  "app-footer": {
    text: "«АЖК» АҚ филиалы-Энергосбыт. «АЛСЕКО» АҚ әзірлеген",
  },
  "auth-view": {
    title: "Жеке тұлғаларға арналған жеке кабинет",
    enter: "Кіру",
    login: "Логин",
    password: "Құпия сөз",
    enter_pass: "KK Требуется пароль",
    back: "<< Кіруге оралу",
    forgot: "Құпиясөзді ұмыттыңыз ба?",
    restore: "Жеке кабинеттің құпиясөзін қалпына келтіру",
    confirm: "Растау",
    message1:
      "Құпиясөзді қалпына келтіру туралы сұрау расталғаннан кейін сіз құпиясөзді қалпына келтіру бойынша нұсқаулықтары бар хатты аласыз.",
    message2:
      "Құпиясөзді қалпына келтіру Жеке кабинетте электрондық мекенжай расталған жағдайда ғана мүмкін болады.",
    "send-restore-mail":
      "Сіздің электрондық мекенжайыңызға құпиясөзді қалпына келтіру бойынша нұсқаулық жіберілді. Поштаңызды тексеріңіз.",
    notice:
      "Электрондық мекенжай бойынша Жеке кабинетке кіру Жеке кабинетте электрондық мекенжай расталған жағдайда ғана мүмкін болады.",
    updated: "Құпиясөз өзгертілді. Жаңа құпиясөзді ",
    updated2: " үшін қолдана аласыз.",
    "new-passw": "Жаңа құпиясөз",
    "retry-pass": "Құпиясөзді растау",
  },
  "form-validator": {
    required: "Міндетті түрде толтырылуы қажет жол",
    "string-max": "Жолдың максималды ұзындығы {max} таңба",
    "string-min": "Жолдың минималды ұзындығы {min} таңба",
    bin: "БСН форматы қате",
    iin: "ЖСН форматы қате",
    email: "Қате email енгізілген",
    decimal3: "KZ Числовое поле, 10 знаков с точностью до тысячных",
    decimal2: "Сандық жол, жүзге дейінгі дәлдікпен 10 белгі",
    decimal: "KZ Числовое поле, 10 знаков",
    checkMoreWhen: "Кейінгі көрсеткіштер алдыңғыға қарағанда үлкен болуы керек",
    accountId: "Қате дербес шот",
    pass_rep_incorr: "Енгізілген құпия сөздер сәйкес келмейді.",
    pass:
      "Енгізілген құпиясөз қауіпсіздік талаптарына сәйкес келмейді. Жаңа құпиясөзде болуы керек: Ең аз дегенде 8; ең көп дегенде 12; таңба 1 сан; жоғарғы регистрдегі латын әліпбиінің 1 әрпі; төменгі регистрдегі латын әліпбиінің 1 әрпі; 1 арнайы таңба (@#$%&); Енгізу үшін тек латын алфавитінің әріптерін қолданыңыз;",
    pass_create:
      "Пайдаланушының кабинетіне кіру үшін жаңа құпиясөзді енгізіңіз.",
    link_expired:
      'Осы сілтеменің қолданылу мерзімі аяқталды. Жаңа сілтеме алу үшін "Құпия сөзді қалпына келтіру" батырмасын  басыңыз',
    link_expired2: "Сілтеме ескірген немесе бұрын қолданылған",
    checkDates: "Көрсеткіштерді алудың соңғы қате уақыты көрсетілген",
  },
  $vuetify: {
    datePicker: {
      itemsSelected: "{0} таңдалған",
      nextMonthAriaLabel: "Келесі ай",
      nextYearAriaLabel: "Келесі жыл",
      prevMonthAriaLabel: "Алдыңғы ай",
      prevYearAriaLabel: "Алдыңғы жыл",
    },
    dataIterator: {
      rowsPerPageText: "Парақтағы жолдар:",
      rowsPerPageAll: "Барлығы",
      pageText: "{2}-ң {0}-{1}",
      noResultsText: "Тиісті жолдар табылмады",
      nextPage: "Келесі бет",
      prevPage: "Алдыңғы бет",
      loadingText: "Жүктеу",
    },
    dataFooter: {
      rowsPerPageText: "Парақтағы жолдар:",
      itemsPerPageAll: "Барлығы",
      pageText: "{2}-ң {0}-{1}",
      noResultsText: "Тиісті жолдар табылмады",
      nextPage: "Келесі бет",
      prevPage: "Алдыңғы бет",
      loadingText: "Жүктеу",
    },
    dataTable: {
      itemsPerPageText: "Парақтағы жолдар:",
      sortBy: "Cұрыптау",
      ariaLabel: {
        activateAscending: "KZ Активирована сортировка",
        sortNone: "KZ Без сортировки",
        activateNone: "KZ Сортировка не активна",
      },
    },
    noDataText: "Көрсету үшін деректер жоқ",
    carousel: {
      prev: "Предыдущий визуальный",
      next: "Следующий визуальный",
    },
  },
  "app-menu": {
    "account-list": "Қолжетімді дербес шоттар",
    "account-info": "Дербес шоты бойынша ақпарат",
    "service-info": "Қызметтер бойынша ақпарат",
    calculate: "Электр энергиясы бойынша ...",
    pays: "Төлемдер",
    invoices: "Түбіртектер",
    requests: "Өтінім беру",
    "change-pwd": "Құпиясөзді өзгерту",
    "change-email": "E-mail-ді өзгерту",
    "change-personal": "Дербес баптаулар",
  },
  "account-info": {
    add: "Жаңа дербес шотты қосу",
    addB: "Жаңа дербес шотты қосу",
    accNum: "Дербес шот №",
    month: "Соңғы төлемнің айы мен жылы",
    sumLastPay: "Соңғы төлем сомасы",
    addBtn: "Қосу",
    "account-exists": "Көрсетілген жеке шот нөмірі тіркелген болатын",
    "account-not-exists":
      "«АлматыЭнергоСбыт» ЖШС №{account} дербес шоты бойынша электр энергиясын жеткізуші болып табылмайды.",
    InvalidPayDate: "Төлемақы мәліметтер базасынан табылмады.",
    InvalidPaymentSum: "Төлемақы сомасы соңғы төлемге сәйкеспейді.",
    "add-error":
      "Дербес шотты қосу мүмкін болмады. Кейінірек қайталап көріңіз.",
    "add-invalid-data":
      "Дербес шот табылмады немесе соңғы төлемнің айы не сомасы қате көрсетілген. Енгізілген деректерді тексеріңіз.",
    "add-too-many-attempts":
      "Дербес шот бойынша деректерді енгізу әрекеттерінің саны асып кетті. {minutes} минуттан кейін қайталаңыз.",
    delete: "Сіз шынымен №{account} дербес шотын жойғыңыз келе ме?",
    qty: "Тұрақты тұратындар саны",
    info: "№{AccountId} Дербес шот бойынша ақпарат",
    payer: "Төлеуші",
    adres: "Мекенжай",
    poverka: "Санауыштардың сәйкестігін тексеру уақыты",
    poverkatext:
      "Әр санауыштың сәйкестігін растау кезеңі бар, яғни бұл кезеңде санауыш дұрыс жұмыс істеп тұр деп саналады. Бұл санауыштың төлқұжатында көрсетілген. Осы кезең аяқталған соң ол дұрыс істеп тұр деген кепілдік жоқ, сондықтан ол  сәйкестікті растаудан өтуі керек немесе оны ауыстыру қажет.",
    change: "Есептегіштерді ауыстыру күні",
    electro: "Электр қуаты",
    changes: "Санауыш № {number}",
    //changes2: ", келесі мемлекеттік тексеру жүргізу күні {date}",
    changes2: "",
  },
  "service-info": {
    title: "Қызметтер бойынша ақпарат, төлемдер ({date} төлемдер ескерілді)",
    serv: "Қызмет атауы",
    period_start: "Кезеңді таңдау",
    period_end: "дейін",
    supplier: "Жеткізуші:",
    "year-month": "Ай/жыл",
    "begin-saldo": "Бастапқы сальдо",
    calc: "Есептеу",
    edits: "Түзетулер",
    pays: "Төлемдер",
    saldo: "Соңғы сальдо",
    print: "Басып шығару",
  },
  calculate: {
    title: "Электр энергиясы бойынша төлемдерді есептеу",
    counter: "Есептегіш",
    number: "Санауыш №",
    install: "Санауыштың орнатылған күні:",
    type: "Түрі:",
    prev:
      "Көрсеткіштерді алудың алдыңғы күні және электр есептегіштің көрсеткіштері",
    data: "Күні: ",
    counts: "Көрсеткіштер",
    current:
      "Көрсеткіштерді алудың келесі күні және электр есептегіштің көрсеткіштері",
    calc: "Есептеу",
    counts_day: "Күні көрсеткіштер",
    counts_nigth: "Тұні көрсеткіштер",
  },
  pays: {
    title: "Төлемдер",
    date: "Күні",
    "sum-pay": "Төлем сомасы",
    bank: "Банк",
    info: "Төлем бойынша ақпарат:",
    serv: "Қызмет атауы",
    sum_pay: "Төленген сома",
  },
  invoices: {
    title: "Түбіртектер",
    "year-month": "Ай/жыл",
    fix_summ: "Төленетін сома",
    kvit: "Түбіртек",
    oborot: "Шоттың сыртқы жағы",
    serv: "Қызмет атауы",
    info: "Түбіртек бойынша ақпарат:",
    view: "Қарау",
  },
  "change-pwd": {
    title: "Құпиясөзді өзгерту",
    old: "Ағымдағы құпиясөз",
    new: "Жаңа құпиясөз",
    retry: "Құпиясөзді растау",
    save: "Сақтау",
    incorrectCurrent:
      "Бұрынғы құпия сөз қате енгізілген. Құпия сөзді ұмытқан жағдайда, құпия сөзді қалпына келтіру жүйесін пайдаланыңыз",
    newAndOld:
      "Жаңа құпия сөз бұрынғыдан кемінде  бір таңбаға өзгеше болуы тиіс",
    newPwdSetted: "Жаңа құпиясөз орнатылды",
    tooManyAttempts:
      "Ағымдағы құпиясөзді енгізу әрекеттерінің саны асып кетті. {minutes} минуттан кейін қайталаңыз.",
    error: "Құпиясөзді өзгерту мүмкін болмады. Кейінірек қайталап көріңіз.",
  },
  personal: {
    title: "Дербес баптаулар",
    firstname: "Тегі",
    lastname: "Аты",
    middlename: "Әкесінің аты",
    dataUpdated: "Дербес баптаулар сақталды",
  },
  "change-email": {
    title: "E-mail мекенжайын өзгерту",
    email: "Өзгерту үшін жаңа E-mail мекенжайын енгізіңіз",
    exists: "Мұндай электронды адресті пайдаланушы бар.",
    nothing: "KZ Введенный E-mail соответсвует текущему",
    EmailActivationInfo:
      "Email адресті өзгертуді жалғастыру үшін сізге өзгертуді растау қажет. Өзгертуді растау нұсқаулығы  Сіздің  электрондық адресіңізге жолданған",
    EmailChanged: "Email адресті өзгерту сәтті өтті.",
    secretHashNotFound: "Сілтеме ескірген немесе бұрын пайдаланылған",
    secretHashExpired: "Сілтеме ескірген немесе бұрын пайдаланылған",
  },
  registr: {
    btn: "Тіркелу",
    title: "Тіркеу",
    att: "Назар аударыңыз. ",
    know: "Тіркеуді жалғастыру үшін соңғы төлемақы",
    "sum-day": " сомасы мен күнін білу керек",
    enter: "Кіру үшін қажетті ақпарат",
    test: "Тексеру ақпараты",
    cancel: "Болдырмау",
    days:
      "Терминал арқылы немесе банк бөлімшелерінде жасалған төлем есепшотқа 3-4 жұмыс күні ішінде түседі",
    pays:
      "«АЛСЕКО» АҚ түбіртегі бойынша төленген жалпы сома тиынымен бірге есептеліп, нүкте арқылы жазылуы тиіс. Соңғы 6 айдағы төлем мерзімі қарастырылады.",
    RegistrationError:
      "Тіркеуді орындау мүмкін болмады. Кейінірек қайталап көріңіз.",
    RegistrationSuccess:
      "Тіркеу сәтті өтті. Жеке  кабинетпен жұмыс істеу үшін Сізге аккаунтты белсендіру керек. Аккаунтты  белсендіру жайлы нұсқау Сіздің электронды адресіңізге жолданды.",
    requared: "Міндетті түрде толтырылуы қажет жолдар",
  },
};
